export let data = {
    data: {
        "responseHeader": {
            "statusCode": "SUCCESS"
        },
        "name": "MARTINE",
        "surname": "AHMAD",
        "memberID": "TK123456789",
        "memberType": "CLSC",
        "cabinType": "C",
        "totalMiles": "15000",
        "seatNumber": "05F",
        "passportNumber": "A12345678",
        "tcIdentity": null,
        "email": "ALEX123456@GMAIL.COM",
        "jwt": "eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjp7fSwic3ViIjoiT25ib2FyZCIsImlhdCI6MTc0ODk0ODc1OCwiZXhwIjoxNzQ5MDM1MTU4fQ.xH2T6bKfTnRp2bKailJ825Sh5vF_DrUvy5npnvrFyis",
        "quotas": {
            "quotaResult": {
                "purchase": [
                    {
                        "id": null,
                        "quotaType": "VOLUME",
                        "packageType": "INTERNET",
                        "amount": 250,
                        "isUnlimited": false,
                        "unit": "MB",
                        "purchaseInfo": null,
                        "isFavor": false,
                        "info_tr": null,
                        "info_en": null,
                        "info_desc_tr": null,
                        "info_desc_en": null,
                        "wifiPackageId": null,
                        "accessGranted": false,
                        "campaignType": null
                    }
                ],
                "nonPurchase": [
                    {
                        "id": null,
                        "quotaType": "VOLUME",
                        "packageType": "INTERNET",
                        "amount": 1024.0,
                        "isUnlimited": false,
                        "unit": "MB",
                        "purchaseInfo": null,
                        "isFavor": false,
                        "info_tr": null,
                        "info_en": null,
                        "info_desc_tr": null,
                        "info_desc_en": null,
                        "wifiPackageId": null,
                        "accessGranted": false,
                        "campaignType": null
                    },
                    {
                        "id": 983,
                        "quotaType": "DURATION",
                        "packageType": "CHAT",
                        "amount": 1320.0,
                        "isUnlimited": true,
                        "unit": "MINUTES",
                        "purchaseInfo": null,
                        "isFavor": false,
                        "info_tr": "Miles&Smiles Classic Program Üyelerimiz",
                        "info_en": "Miles&Smiles Classic Members",
                        "info_desc_tr": "Miles&Smiles Classic Program Üyelerimiz",
                        "info_desc_en": "Miles&Smiles Classic Members",
                        "wifiPackageId": 983,
                        "accessGranted": false,
                        "campaignType": null
                    }
                ],
                "favor": [],
                "campaign": []
            },
            "quotaList": [
                {
                    "id": 927,
                    "quotaType": "VOLUME",
                    "packageType": "INTERNET",
                    "amount": 1.0,
                    "isUnlimited": false,
                    "unit": "GB",
                    "purchaseInfo": null,
                    "isFavor": false,
                    "info_tr": "1 GB Internet",
                    "info_en": "1 GB Internet",
                    "info_desc_tr": "1 GB Internet",
                    "info_desc_en": "1 GB Internet",
                    "wifiPackageId": 927,
                    "accessGranted": true,
                    "campaignType": null
                },
                {
                    "id": 983,
                    "quotaType": "DURATION",
                    "packageType": "CHAT",
                    "amount": 22.0,
                    "isUnlimited": true,
                    "unit": "HOURS",
                    "purchaseInfo": null,
                    "isFavor": false,
                    "info_tr": "Miles&Smiles Classic Program Üyelerimiz",
                    "info_en": "Miles&Smiles Classic Members",
                    "info_desc_tr": "Miles&Smiles Classic Program Üyelerimiz",
                    "info_desc_en": "Miles&Smiles Classic Members",
                    "wifiPackageId": 983,
                    "accessGranted": true,
                    "campaignType": null
                },
                {
                    "id": 1162,
                    "quotaType": "VOLUME",
                    "packageType": "INTERNET",
                    "amount": 250,
                    "isUnlimited": false,
                    "unit": "MB",
                    "purchaseInfo": "CREDIT_CARD",
                    "isFavor": false,
                    "info_tr": "250 MB",
                    "info_en": "250 MB",
                    "info_desc_tr": "250 MB",
                    "info_desc_en": "250 MB",
                    "wifiPackageId": null,
                    "accessGranted": false,
                    "campaignType": null
                }
            ]
        },
        "messageList": [
            {
                "reason": null,
                "localizedDescription": "Request Processed Successfully",
                "messageType": null,
                "errorType": null,
                "messageCode": "TK-0000"
            }
        ],
        "internetAccessResponse": [
            {
                "respCode": null,
                "respMessage": "Unexpected Error"
            }
        ]
    },
    error: false
};